<div class="agents-container" *ngIf="agents.length" else noData>
  <div class="filters">
    <div class="search-filter-group">
      <button class="action-btn secondary-btn icon-btn" *ngIf="assignView" (click)="cancelAssignMore()">
        <span class="icon">
          <app-svg-icon svgIcon="close-cc"></app-svg-icon>
        </span>
      </button>
      <!-- Search Box -->
      <div class="standard-input has-icon search-box">
        <div class="input-container">
          <input type="text" placeholder="{{ 'agent.listing.search' | translate }}" [formControl]="searchInput" (input)="search($event)" />
          <span class="btn-icon" style="cursor: default">
            <app-svg-icon svgIcon="search_icon"></app-svg-icon>
          </span>
        </div>
      </div>
      <div style="display: flex; align-items: center; gap: 20px; margin-left: auto;">
        <span class="title">{{ this.agents.length }} {{ 'commission.details.agents_assigned' | translate }}</span>
        <button class="action-btn secondary-btn"  (click)="assignMore()" *ngIf="!assignView && agentsList.length > 0">
          <span class="icon">
            <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
          </span>
          {{ 'commission.actions.assign_more' | translate }}
        </button>
        <button class="action-btn primary-btn" *ngIf="assignView" (click)="assign()">
          <span class="icon">
            <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
          </span>
          {{ 'commission.actions.assign' | translate }}
        </button>
      </div>
      <button
        *ngIf="!assignView && selectedAgents.length"
        class="action-btn secondary-btn icon-btn"
        style="border-color: #970000; color: #970000;"
        (click)="removeSelectedAgents()"
      >
        <app-svg-icon svgIcon="trash-cc"></app-svg-icon>
      </button>
    </div>
  </div>
  <div class="agents-content">
    <table class="agents-table">
      <thead>
        <tr class="row header">
          <th>
            <mat-checkbox [checked]="isAllAgentsSelected()" [indeterminate]="isPartialSelectedAll()" (change)="toggleAllAgents($event.checked)">
            </mat-checkbox>
            <div [title]="'agent.listing.fullname' | translate">
              {{ "agent.listing.fullname" | translate }}
            </div>
          </th>
          <th [title]="'commission.new.summary.brand_commission' | translate">{{ "commission.new.summary.brand_commission" | translate }}</th>
          <th [title]="'commission.new.summary.agent_override' | translate">{{ "commission.new.summary.agent_override" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <cdk-virtual-scroll-viewport itemSize="50" class="agents-viewport">
          <ng-container *cdkVirtualFor="let agent of filteredAgents; trackBy: trackByAgentId">
            <tr class="row">
              <!-- Agent's fullname -->
              <td>
                <mat-checkbox
                  [disableRipple]="true"
                  [checked]="selectedAgents.includes(agent.id!)"
                  (change)="toggleAgent(agent.id!, $event.checked)"
                  (click)="$event.stopPropagation()"
                ></mat-checkbox>
                <span class="truncate" style="width: 200px" [title]="agent.first_name + ' ' + agent.last_name">
                  {{ agent.first_name + " " + agent.last_name }}
                </span>
              </td>
              <!-- Brand Commission Count -->
              <td>0</td>
              <!-- Agent Override -->
              <td>--</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!agents.length">
            <div style="height: 200px; display: flex; align-items: center; justify-content: center" class="secondary-text">
              {{ "agent.listing.no_data" | translate }}
            </div>
          </ng-container>
        </cdk-virtual-scroll-viewport>
      </tbody>
    </table>
  </div>
</div>
<div class="no-data-container" *ngIf="agents.length <= 0">
  <img src="assets/images/briefcase-illustration.svg" alt="" />
  <span class="no-data-msg"> {{ "commission.details.no_agents_title" | translate }} </span>
  <p class="no-data-desc">{{ "commission.details.no_agents_desc" | translate }}</p>
  <button class="action-btn primary-btn" (click)="assignMore()">
    <span class="icon">
      <app-svg-icon svgIcon="plus-cc"></app-svg-icon>
    </span>
    <span>{{ "commission.actions.assign_agents" | translate }}</span>
  </button>
</div>
